import { BLOCK_TYPES } from '../utils/constants';
import { DayBlockDTO, IDayBlockDTO } from './day-block';
import { IGradeUnitDayDTO } from './grade-unit/grade-unit-day';

export interface IVideoEmbedBlock extends IDayBlockDTO {
  url: string;
}

export interface IVideoEmbed {
  videoEmbed: string;
}
export class VideoEmbedBlock extends DayBlockDTO implements IVideoEmbedBlock {
  id: number;
  dayNumber: number;
  day: IGradeUnitDayDTO;
  url: string = '';
  blockType: BLOCK_TYPES = BLOCK_TYPES.VideoEmbedBlock;
  position: number = 0;
  embed: any;

  constructor(configOverride?: Partial<IVideoEmbedBlock>) {
    super();
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
